import src from "IMAGE";
export default { src, width: 23, height: 23, blurWidth: 0, blurHeight: 0};
